import React, { useEffect, useState } from "react";
import $ from "jquery"
import close_img from "../../assets/images/close_btn.svg"
import { removeFavouritePdf , getFavouritePdf , shareUserFavourites} from "../../api/user"

const FavouriteComponent = ({handleFavoriteVisibility,favModalVisible,changeLoaderStatus,device}) => {

    const [wishList , setWishList] = useState(null)

    $('#favModal').on('hide.bs.modal', function (e) {

        if(device === undefined) {

          
          $(".navigation-container").show(); 

        }
        $(".nav-header-div").show();
        handleFavoriteVisibility(false)
    });

    const removeWishlist = (id) => {

      let user_id = sessionStorage.getItem("user_id");

      if(user_id) {
        changeLoaderStatus(true)

        removeFavouritePdf({ id : id , user_id : user_id }).then((val) => {

            if(val.data.response === "success") {
              alert("Successfully removed.")

              changeLoaderStatus(false)
              loadWishList();

            }
        })
      }

    }

    const loadWishList = () => {

      let user_id = sessionStorage.getItem("user_id");

      if(user_id) {
        changeLoaderStatus(true)
          getFavouritePdf({user_id : user_id }).then((val) => {

              if(val.data.response === "success") {

                  let wishlists = val.data.wishlists;

                  setWishList(wishlists)
                  changeLoaderStatus(false)

              }

          })

      }
    }

    useEffect(() => {

      if(favModalVisible) {

        loadWishList()
      }


    },[favModalVisible])

    const handleShareFav = () => {
      let user_id = sessionStorage.getItem("user_id");
      if(user_id) {
        changeLoaderStatus(true)

        
        let session_id = sessionStorage.getItem("session_id");
        let sme_session_id = ""
        if (user_id) {

          sme_session_id  = session_id

        }


        shareUserFavourites({user_id : user_id , session_id : sme_session_id}).then((val) => {
          changeLoaderStatus(false)

            if(val.data.response === "success") {

                alert("Successfully shared favourites.")
            }

        })
      }

    }


    return(

        <div className="main_popup">

        <div className="modal fade update_profile_model" id="favModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-body p-0">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { 
                                $("#favModal").modal('hide'); 
                            }}>
                                 <span aria-hidden="true"><img src={close_img} alt="" /></span>
                        </button>
                        <div className="popup_div_favorite modal_description_div p-5">
                            <div className="return_popup text-center">
                                <div className="favorites_inner_div">
                                    <h3>Favorites <a href="#" onClick={handleShareFav}><img src="images/share_icon.svg" className="float-right" alt="" /></a></h3>
                                    <div className="custom_scroll promo_code_pop_inner promo_code_pop_inner3 mt-5">
                                    <table className="table">
                                        <thead className="thead-light">
                                          <tr>
                                            <th scope="col">Title</th>
                                            <th scope="col">Location</th>
                                            <th scope="col">&nbsp;</th>
                                          </tr>
                                        </thead>
                                        <tbody>

                                          {
                                            wishList && wishList.map((val) => {

                                                return(
                                                  <tr>
                                                    <td>{val.title}</td>
                                                    <td>{val.location}</td>
                                                    <td><a href="#" onClick={() => removeWishlist(val.id)}><img src="images/del_icon.svg" alt="" /></a></td>
                                                  </tr>
                                                )
                                            })
                                          }
                                         
                                          <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default FavouriteComponent;